const format = (x: number): string | null => {
  const result = x.toFixed(1).replace('.0', '');
  return result === 'NaN' ? null : result;
};

/** Ex: 1100 -> 1.1
 66000 -> 1.1 */
export const formatTimeNumber = (time: number): string | null => {
  const seconds = time / 1000;

  if (seconds < 60) {
    return format(seconds);
  }
  return format(seconds / 60);
};

/** adds "s" or "min"
 Ex: 12.2 min */
export const formatTime = (time: number, translator: (str: string) => string): string | null => {
  const seconds = time / 1000;

  if (seconds < 60) {
    const numPart = format(seconds);
    return numPart ? `${numPart} ${translator('s')}` : null;
  }

  const numPart = format(seconds / 60);
  return numPart ? `${numPart} ${translator('min')}` : null;
};

export const getTime = (time: number): string => {
  const minutes = Math.floor(time / (1000 * 60));
  const seconds = Math.round((time - minutes * 1000 * 60) / 100) / 10;

  if (Number.isNaN(minutes) || Number.isNaN(seconds)) {
    return '';
  }

  return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};

export const formatAudioTime = (time: number): string => {
  const m = `${Math.floor(time / 60)}`.padStart(2, '0');
  const s = `${Math.round(time % 60)}`.padStart(2, '0');
  return `${m}:${s}`;
};

export const msToTimeFormat = (time: number, withMillis?: boolean): string => {
  let seconds: string | number = time / 1000;
  let hours: string | number = Math.floor(seconds / 3600);

  seconds %= 3600;

  let minutes: string | number = Math.floor(seconds / 60);
  const milliseconds = withMillis ? `.${Math.floor(time % 1000)}` : '';

  seconds = Math.floor(seconds % 60);

  hours = hours < 10 ? `0${hours}` : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  seconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${hours}:${minutes}:${seconds}${milliseconds}`;
};

export const msToSMPTE = (time: number, framerate: number): string => {
  let frame: number | string = Math.floor(((time / 1000) * framerate) % framerate);
  frame = frame < 10 ? `0${frame}` : frame;
  return `${msToTimeFormat(time)}:${frame}`;
};
